import GoogleAnalytics, { trackPageView } from '@redux-beacon/google-analytics';
import { LOCATION_CHANGE } from 'react-router-redux';
import { createMiddleware } from 'redux-beacon';

// Google Analalytics.
const ga = GoogleAnalytics();

// Fetching the Redux Events to track for Google Analtyics.
const eventsMap = {
    [LOCATION_CHANGE]: trackPageView((action) => {
        return {
            page: action.payload.pathname,
        };
    }),
};

// Initialising the Google Analtyics Middleware.
const googleAnalyticsMiddleware = createMiddleware(eventsMap, ga);

export default googleAnalyticsMiddleware;



// WEBPACK FOOTER //
// ./src/store/middleware/googleAnaltyicsMiddleware.js